import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {AsyncStatusesEnum} from '../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {AsyncLoader} from '../../../libs/shared/ui/src/components/loaders/asyncLoader';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface KnowledgeBasePluginErrorBoundaryProps {
  resetErrorBoundary: () => void;
}

/*
 * Style.
 */

const StyledErrorWrapperDiv = styled.div`
  display: grid;
  align-items: center;
  align-content: center;
  grid-row: 1 / span 2;
  height: 100%;
`;

/*
 * Component.
 */

export const KnowledgeBasePluginErrorBoundary: FC<KnowledgeBasePluginErrorBoundaryProps> = ({
  resetErrorBoundary,
}) => (
  <StyledErrorWrapperDiv>
    <AsyncLoader
      status={AsyncStatusesEnum.FAILED}
      size={VisualSizesEnum.EXTRA_LARGE}
      error={<Trans id="knowledge-base-plugin-error-state">Oh no! Something went wrong.</Trans>}
      onRetryClick={resetErrorBoundary}
    />
  </StyledErrorWrapperDiv>
);
